// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".friends-list{margin-top:2rem;color:#4a5568;background:#e6ebf0;border-radius:5px}.friends-list__empty{font-style:italic;text-align:center;padding:1rem}.friends-list__friends{border-collapse:collapse;width:100%}.friends-list__friend td{padding:1.2rem .5rem}.friends-list__friend td:first-child{padding:1.2rem .5rem 1.2rem 1rem;width:0}.friends-list__friend td:last-child{padding-right:1rem}.friends-list__friend+.friends-list__friend td{border-top:1px solid #cbd5e0}", ""]);
// Exports
module.exports = exports;
